import { request } from '@luna/api';
import type { EnvironmentConfig } from '@luna/env';
import { loadEnv } from '@luna/env';
import { logger } from '@luna/logger';
import { COUNTRY_URL_PARAM } from '@shared/environment';

const CONFIG_DOMAIN_SEPARATOR = '_';
const DEFAULT_COUNTRY = 'AT';

const LOCALHOST_HOSTNAME = 'localhost';
const BROWSER_STACK_LOCALHOST_HOSTNAME = 'bs-local.com';

const LOCALHOST_HOSTNAMES = [LOCALHOST_HOSTNAME, BROWSER_STACK_LOCALHOST_HOSTNAME];

export function isLocalhost(hostname: string): boolean {
    return LOCALHOST_HOSTNAMES.includes(hostname);
}

function getCountryForDevelopment(): string {
    return (
        new URLSearchParams(window.location.search).get(COUNTRY_URL_PARAM) ??
        new URLSearchParams(window.location.hash.substring(1)).get(COUNTRY_URL_PARAM) ??
        sessionStorage.getItem('country') ??
        DEFAULT_COUNTRY
    );
}

export function getConfigFileName(hostname: string): string {
    const hostnameParts = hostname.split(/\./gi);
    return `${hostnameParts.reverse().join(CONFIG_DOMAIN_SEPARATOR)}.json`;
}

function getConfigUrl(): string {
    const { hostname } = window.location;

    if (isLocalhost(hostname)) {
        const country = getCountryForDevelopment();
        return `config/${country}_localhost.json`;
    }

    /**
     * Cache busting for the config file is mandatory
     * to avoid deployment issues
     * and be able to instantly update the config.
     */
    return `//${hostname}/config/${getConfigFileName(hostname)}?ts=${Date.now()}`;
}

async function fetchConfig(): Promise<EnvironmentConfig> {
    try {
        return await request<EnvironmentConfig>(getConfigUrl(), {
            skipAuthHeader: true,
        });
    } catch (e) {
        logger.error('George: Configuration file cannot be found', e);

        return {} as EnvironmentConfig;
    }
}

export async function loadConfig(): Promise<void> {
    await loadEnv(fetchConfig);
}
